import { Box, Collapse, Grid, Typography, useMediaQuery, useTheme, MenuItem, ListItemIcon } from "@mui/material";
import CustomDateRange from "../../common/CustomDateRange";
import { DateObject } from "react-multi-date-picker";
import Header from "../../common/Header";
import CustomTextField from "../../common/CustomTextField";
import CustomDropdownField from "../../common/CustomDropdownFiled";
import { AddCircleOutlineOutlined, DoDisturbAltOutlined, ModeOutlined, SearchOutlined, VpnKey, CheckCircleOutline, AssignmentReturnedOutlined, TrackChanges, LockOpenOutlined, SecurityOutlined, ExitToApp, CloudDownload, DownloadOutlined, KeyboardArrowDown } from "@mui/icons-material";
import Card from "../../common/Card";
import { useForm } from "react-hook-form";
import {
  SearchUsers, fetchAllUserRoles, fetchUserProfileById, searchUserList, useUserReducer, UserRole, resetUserState,
  fetchAgenciesListUserSlice, fetchManufacturersListUserSlice, getPracticesByUserRoleUserSlice, fetchActiveBillersUserSlice,
  UserDTO
} from "../../../redux/slice/userSlice";
import Button from "../../common/Button";
import Table, { Row as TableRow} from "../../common/CustomTable";
import { useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import LegacyToolBar from "../../common/LegacyToolBar";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import { AgencyInfo, ManufacturerInfo, setSingleAlertObj, showHideLoadingDialog, SingleAlertInfo, } from "../../../redux/slice/commonSlice";
import PasswordResetPopup from "../../common/PasswordResetPopup";
import { convertUTCtoLocal, formatDate, hideElement, sortNames } from "../../../utils/Utility";
import { createListSort } from "../../../utils/listSort";
import CustomPatternTextField from "../../common/CustomPatternTextField";
import InactiveUserPopup from "./InactiveUserPopup";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { selectIsValueFoundInToken, selectTokenValues, useAuthSlice } from "../../../redux/slice/authSlice";
import CustomIconButton from "../../common/CustomIconButton";
import CustomMultipleDropDown from "../../common/CustomMultipleDropDown";
import { AGENCY_USER, AUDIT_ENTITYS, CAN_ACCESS_APPLICATION, CAN_ACCESS_USER_PERMISSION, EXPORTABLE_ITEMS, MANUFACTURE_USER, PRACTICE_USER, providerRoleId, USER_ROLE_ENTITY_NAMES, USER_ROLES } from "../../../constants/applicationConstants";
import { PracticeInfo } from "../../../redux/slice/practiceSlice";
import { BillerInfo } from "../../../redux/slice/practice/practiceApproveSlice";
import { getSearchCriteriaFromSessionStorage, saveSelectionForPage, setSearchCriteriaToSessionStorage } from "../../../utils/StorageUtils";
import UploadBaaPopup from "../baa/UploadBaaPopup";
import CustomSingleAlert from "../../common/CustomSingleAlert";
import ErrorDialog from "../../common/ErrorDialog";
import ExportToExcel from "../../common/ExportToExcel";
import StyledMenu from "../../common/StyledMenu";
import { fetchIsLastProviderByUser, usePracticeProvidersSlice } from "../../../redux/slice/practice/practiceProvidersSlice";
import { useNavigation } from "../../../hooks/useNavigation";
import { useFilterPanelFocus } from "../../../hooks/useFilterPanelFocus";
import { useListPageStyles } from "../../common/useListPageStyles";

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: "right" | "center" | "left";
  format?: (value: number) => string;
}

const columns: Column[] = [
  { id: "email", label: "Email", minWidth: 100 },
  { id: "userRole", label: "User Type", minWidth: 100 },
  { id: "userName", label: "Name", minWidth: 100 },
  { id: "phone", label: "Phone", minWidth: 100 },
  { id: "lastLoginAt", label: "Last Login Time", minWidth: 100 },
  { id: "userStatus", label: "Status", minWidth: 100 },
  { id: "action", label: "Action", minWidth: 100, },
];

const userListSort = createListSort(
  ["email", "userRole", "userName", "lastLoginAt", "userStatus"] as const,
  {
    email: "email",
    userRole: "userRole",
    userName: "userName",
    lastLoginAt: "lastLoginAt",
    userStatus: "userStatus",
  }
);



interface Row {
  email: string;
  userName: string;
  firstName: string;
  middleName: string;
  lastName: string;
  userRole: string;
  phone: string;
  createDate: String;
  userStatus: string;
  lastLoginAt: String;
  action: JSX.Element;
  userId: string;
}

type Option = {
  label: string;
  value: string | number;
}

type TypeOption = {
  label: string;
  value: string;
}

const PRACTICE_ENTITY: string = "Practice";
const AGENCY_ENTITY: string = "Agency";
const MANUFACTURER_ENTITY: string = "Manufacturer";
const BILLER_ENTITY: string = "Biller";

const NONE_ENTITY: string = "None";

const ITEMS_PER_PAGE = 20;

const orderedUserList = [
  "Account Representative",
  "Admin",
  "All Agency Users",
  "Agency Admin",
  "Agency Staff",
  "Biller",
  "All Manufacturer Users",
  "Manufacturer Admin",
  "Manufacturer IVR",
  "Manufacturer Service",
  "Manufacturer Staff",
  "All Practice Users",
  "Practice Admin",
  "Practice Staff",
  "Provider"
];

const UserList = () => {

  const location = useLocation();
  const { navigate } = useNavigation();
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    cardSx,
    filterPanelSx,
    filterFieldLabelSx,
    primaryActionBtnSx,
    outlineBtnSx,
    exportMenuPaperSx,
    exportMenuItemBtnSx,
    tableSx,
  } = useListPageStyles();

  const exportBtnSx = {
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.86rem",
    borderRadius: "10px",
    py: 1.05,
    px: 1.6,
    color: "#14B8A6",
    borderColor: "rgba(20,184,166,0.55)",
    backgroundColor: theme.palette.mode === "dark" ? "rgba(20,184,166,0.08)" : "rgba(20,184,166,0.04)",
    whiteSpace: "nowrap",
    "& .MuiSvgIcon-root": {
      color: "#14B8A6",
    },
    "&:hover": {
      color: "#fff",
      borderColor: "#14B8A6",
      backgroundColor: "#14B8A6",
      boxShadow: "0 6px 22px rgba(20,184,166,0.28)",
      "& .MuiSvgIcon-root": {
        color: "#fff",
      },
    },
  };

  const { control, handleSubmit, watch, reset, setValue, getValues } = useForm<SearchUsers>();

  const [loggedInRoleEntity, setLoggedInRoleEntity] = useState<string>("");
  const [selectedRoleEntity, setSelectedRoleEntity] = useState<string>("");
  const [extraUserRoleIdsLocal, setExtraUserRoleIdsLocal] = useState<number[]>([]);
  const [onlyExtraRoleEntity, setOnlyExtraRoleEntity] = useState<string>("");
  const [allExtraRoleEntityLoaded, setAllExtraRoleEntityLoaded] = useState(false);
  const [showPasswordResetPopup, setShowPasswordResetPopup] = useState(false);
  const [showInactivePopup, setShowInactivePopup] = useState<boolean>(false);
  const [userEmail, setUserEmail] = useState("");
  const [userID, setUserID] = useState(0);
  const [userProfileStatus, setUserProfileStatus] = useState("");
  const [showCard, setShowCard] = useState(false);
  const {
    filterPanelRef,
    toggleFilterPanel,
    handleFilterPanelEntering,
    handleFilterPanelEntered,
    handleFilterPanelExited,
  } = useFilterPanelFocus(showCard, setShowCard);
  //CS-1744 - Start
  const [isDateRangeChanged, setIsDateRangeChanged] = useState(false);
  const [isClearDateRange, setIsClearDateRange] = useState(false);
  //CS-1744 - End
  const [showBaaPopup, setShowBaaPopup] = useState<{show: boolean, userEntity: "PRACTICE" | "USER", details:PracticeInfo | null}>();
  const [baaAlert, setBaaAlert] = useState<{show:boolean, obj: SingleAlertInfo}>();
  const [inactiveProvider, setInactiveProvider] = useState<{
    message: string;
    show: boolean;
  }>({ message: "", show: false });
  const [anchorElMenu, setAnchorElMenu] = useState<null | HTMLElement>(null);
  const {isLastPracticeProvider} = usePracticeProvidersSlice();
  //CS-1071 - Start
  const [activeButtonId, setActiveButtonId] = useState<string | null>(null);
  //CS-1071 - End
  const [tableSort, setTableSort] = useState<Pick<SearchUsers, "sortBy" | "sortOrder">>({});
  const [searchCriteria, setSearchCriteria] = useState<SearchUsers>({
    firstName: "",
    lastName: "",
    userRoleIdsForm: null,
    userName: "",
    extraEntityId: undefined,
    extraRoleIds: [],
    entityId: null,
    phone: "",
    userStatus: [],
    currentPage: 1,
    itemsPerPage: ITEMS_PER_PAGE,
    //CS-1744 - Start
    fromDate: "",
    toDate: "",
    //CS-1744 - End
  });

  const { searchUsers, userExportList, userRoles, agencyInfoListUserSlice, manufacturerInfoListUserSlice,
    practiceByUserRoleUserSlice, billerListUserSlice } = useUserReducer();
  const { userInfo } = useAuthSlice();
  const loggedInUserRole = userInfo.userRole;

  const managingUserRoles = useSelector((state: RootState) => selectTokenValues("canManageUsers")(state));
  const canAuditUser = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessAuditAction", AUDIT_ENTITYS.USERAUDIT)(state));
  const canAccessUserPermissionView = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessUserPermission", CAN_ACCESS_USER_PERMISSION.VIEW)(state));
  const canExportList = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessExportExcel", EXPORTABLE_ITEMS.USER)(state));

  //If Only Create Role is present then remove action column
  const filteredColumns = managingUserRoles && managingUserRoles.includes(USER_ROLES.ROLE_ONLY_CREATE)
    ? columns.filter(column => column.id !== 'action') // Remove 'action' column
    : columns;

  const statusOptions = useMemo(() => {
    let options: { label: string, value: any }[] = [
      { value: "Active", label: "Active" },
      { value: "Inactive", label: "Inactive" },
    ];
    setValue("userStatus", ["Active"]);
    return options;
  }, []);

  const sortUserTypeList = (userRoles: TypeOption[], key: keyof TypeOption) => {
    return userRoles.sort((a, b) => {
      const indexA = orderedUserList.indexOf(a[key]);
      const indexB = orderedUserList.indexOf(b[key]);
      return indexA - indexB;
    });
  };

  const ENTITY_MERGE_MAP: Record<string, string> = {
    ACCOUNTEXECUTIVE: 'AGENCY',
  };

  const getNormalizedEntity = (entity: string | undefined | null): string | null => {
    if (!entity) return null;
    const upperEntity = entity.toUpperCase();
    return ENTITY_MERGE_MAP[upperEntity] || upperEntity;
  };

  const userTypesList = useMemo(() => {
    let allUserRoles: TypeOption[] = [];
    let loggedInUserEntityRelatedRoles: number[] = [];
    let extraUserRoleIds: number[] = [];
    let allEntityRelatedRoles: string[] = [];
    let entityRelatedLoggedInUser: boolean = false;

    if (userRoles?.length && managingUserRoles?.length) {
      const availableUserRoles = userRoles.filter((role: UserRole) =>
        managingUserRoles.includes(role.roleName)
      );

      const entityGroupedRoles: Record<string, number[]> = {};

      availableUserRoles.forEach((role: UserRole) => {
        allUserRoles.push({ label: role.roleDisplayValue, value: role.userRoleId });

        const normalizedEntity = getNormalizedEntity(role.entityName);

        if (normalizedEntity) {
          if (!entityGroupedRoles[normalizedEntity]) {
            entityGroupedRoles[normalizedEntity] = [];
          }
          entityGroupedRoles[normalizedEntity].push(parseInt(role.userRoleId));

          if (!allEntityRelatedRoles.includes(normalizedEntity)) {
            allEntityRelatedRoles.push(normalizedEntity);
          }

          if (loggedInUserRole?.startsWith(`ROLE_${normalizedEntity}`)) {
            entityRelatedLoggedInUser = true;
            loggedInUserEntityRelatedRoles.push(parseInt(role.userRoleId));
          }
        }
      });

      Object.entries(entityGroupedRoles).forEach(([entity, roleIds]) => {
        if (roleIds.length > 1) {
          allUserRoles.push({
            label: `All ${entity.charAt(0) + entity.slice(1).toLowerCase()} Users`,
            value: roleIds.join("-")
          });
        }
      });

      if (entityRelatedLoggedInUser) {
        allUserRoles.forEach((option) => {
          if (
            Number(option.value) &&
            !loggedInUserEntityRelatedRoles.includes(Number(option.value))
          ) {
            extraUserRoleIds.push(Number(option.value));
          }
        });

        if (extraUserRoleIds.length > 1) {
          setValue('extraRoleIds', extraUserRoleIds);
          setExtraUserRoleIdsLocal(extraUserRoleIds);
        }
      }

      if (loggedInUserEntityRelatedRoles.length === 0 && allEntityRelatedRoles.length === 1) {
        setSelectedRoleEntity(allEntityRelatedRoles[0]);
        setOnlyExtraRoleEntity(allEntityRelatedRoles[0]);
      } else {
        setOnlyExtraRoleEntity(NONE_ENTITY);
      }

      allUserRoles = sortUserTypeList(allUserRoles, 'label');

      if (allUserRoles.length === 1) {
        setValue('userRoleIdsForm', parseInt(allUserRoles[0]?.value));
      }
    }

    return allUserRoles;
  }, [userRoles, managingUserRoles]);

  const manufacturersList = useMemo(() => {
    let options: Option[] = [];
    if (manufacturerInfoListUserSlice && manufacturerInfoListUserSlice.length > 0) {
      const sortedInfo: ManufacturerInfo[] = sortNames(manufacturerInfoListUserSlice, 'manufacturerName');
      sortedInfo?.map(option => {
        options.push({ label: option.manufacturerName, value: option.manufacturerId });
      });
    }
    return options;
  }, [manufacturerInfoListUserSlice]);

  const agencyList = useMemo(() => {
    let options: Option[] = [];

    if (agencyInfoListUserSlice && Array.isArray(agencyInfoListUserSlice)) {
      const sortedAgencyList = sortNames(agencyInfoListUserSlice, 'agencyName');

      sortedAgencyList.forEach((agency: AgencyInfo) => {
        options.push({ label: agency.agencyName, value: agency.agencyId });
      });
    }
    return options;
  }, [agencyInfoListUserSlice]);

  const billerUsersList = useMemo(() => {
    let options: Option[] = [];
    if (billerListUserSlice && billerListUserSlice.length > 0) {
      const sortedInfo: BillerInfo[] = sortNames(billerListUserSlice, 'billerName');
      sortedInfo?.map(option => {
        options.push({ label: option.billerName, value: option.billerId });
      });
    }
    return options;
  }, [billerListUserSlice]);

  const practiceList = useMemo(() => {
    let options: Option[] = [];
    if (practiceByUserRoleUserSlice && practiceByUserRoleUserSlice.length > 0) {
      const sortedPracticeInfo: PracticeInfo[] = sortNames(practiceByUserRoleUserSlice, 'practiceName');
      sortedPracticeInfo?.map(practice => {
        options.push({ value: practice.practiceId, label: practice.practiceName });
      });
    }
    return options;
  }, [practiceByUserRoleUserSlice]);

  useEffect(() => {
    if (manufacturerInfoListUserSlice && manufacturerInfoListUserSlice.length > 0) {
      if (manufacturerInfoListUserSlice.length === 1) {
        if (((loggedInRoleEntity === MANUFACTURER_ENTITY && !selectedRoleEntity) || (selectedRoleEntity === MANUFACTURER_ENTITY && !loggedInRoleEntity)
          || (selectedRoleEntity && loggedInRoleEntity && loggedInRoleEntity === MANUFACTURER_ENTITY))) {
          setValue('entityId', Number(manufacturerInfoListUserSlice[0]?.manufacturerId));
        }
        if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === MANUFACTURER_ENTITY) {
          setValue('extraEntityId', Number(manufacturerInfoListUserSlice[0]?.manufacturerId));
        }
      }
    }
  }, [manufacturerInfoListUserSlice, loggedInRoleEntity, selectedRoleEntity]);

  useEffect(() => {
    if (agencyInfoListUserSlice && agencyInfoListUserSlice.length > 0) {
      if (agencyInfoListUserSlice.length === 1) {
        if (((loggedInRoleEntity === AGENCY_ENTITY && !selectedRoleEntity) || (selectedRoleEntity === AGENCY_ENTITY && !loggedInRoleEntity)
          || (selectedRoleEntity && loggedInRoleEntity && loggedInRoleEntity === AGENCY_ENTITY))) {
          setValue('entityId', Number(agencyInfoListUserSlice[0]?.agencyId));
        }
        if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === AGENCY_ENTITY) {
          setValue('extraEntityId', Number(agencyInfoListUserSlice[0]?.agencyId));
        }
      }
    }
  }, [agencyInfoListUserSlice, loggedInRoleEntity, selectedRoleEntity]);
  //CS-1071 - Start
  useEffect(() => {
    const saved = sessionStorage.getItem("activeActionButtonId");
    if (saved) {
      setActiveButtonId(saved);
    }
  }, []);
  //CS-1071 - End
  useEffect(() => {
    if (billerListUserSlice && billerListUserSlice.length > 0) {
      if (billerListUserSlice.length === 1) {
        if (((loggedInRoleEntity === BILLER_ENTITY && !selectedRoleEntity) || (selectedRoleEntity === BILLER_ENTITY && !loggedInRoleEntity)
          || (selectedRoleEntity && loggedInRoleEntity && loggedInRoleEntity === BILLER_ENTITY))) {
          setValue('entityId', Number(billerListUserSlice[0]?.billerId));
        }
        if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === BILLER_ENTITY) {
          setValue('extraEntityId', Number(billerListUserSlice[0]?.billerId));
        }
      }
    }
  }, [billerListUserSlice, loggedInRoleEntity, selectedRoleEntity]);

  useEffect(() => {
    if (practiceByUserRoleUserSlice && practiceByUserRoleUserSlice.length > 0) {
      if (practiceByUserRoleUserSlice.length === 1) {
        if (((loggedInRoleEntity === PRACTICE_ENTITY && !selectedRoleEntity) || (selectedRoleEntity === PRACTICE_ENTITY && !loggedInRoleEntity)
          || (selectedRoleEntity && loggedInRoleEntity && loggedInRoleEntity === PRACTICE_ENTITY))) {
          setValue('entityId', Number(practiceByUserRoleUserSlice[0]?.practiceId));
        }
        if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === PRACTICE_ENTITY) {
          setValue('extraEntityId', Number(practiceByUserRoleUserSlice[0]?.practiceId));
        }
      }
    }
  }, [practiceByUserRoleUserSlice, loggedInRoleEntity, selectedRoleEntity]);

  useEffect(() => {
    if (onlyExtraRoleEntity && onlyExtraRoleEntity !== NONE_ENTITY) {
      fetchExtraRoleEntityLists();
    }
  }, [onlyExtraRoleEntity]);

  const fetchExtraRoleEntityLists = async () => {
    if (onlyExtraRoleEntity === AGENCY_ENTITY) {
      const responseAgencies = await dispatch(fetchAgenciesListUserSlice());
    } else if (onlyExtraRoleEntity === MANUFACTURER_ENTITY) {
      const responseManufacturers = await dispatch(fetchManufacturersListUserSlice());
    } else if (onlyExtraRoleEntity === PRACTICE_ENTITY) {
      const responsePractices = await dispatch(getPracticesByUserRoleUserSlice(true));
    } else if (onlyExtraRoleEntity === BILLER_ENTITY) {
      const responseBillers = await dispatch(fetchActiveBillersUserSlice());
    }
    setAllExtraRoleEntityLoaded(true);
  }

  useEffect(() => {
    const userRoleIdsFormLocal: any = getValues("userRoleIdsForm");
    if (!userRoleIdsFormLocal) {
      if (onlyExtraRoleEntity && onlyExtraRoleEntity !== NONE_ENTITY) {
        setSelectedRoleEntity(onlyExtraRoleEntity);
      } else {
        setSelectedRoleEntity("");
      }
      setValue('extraRoleIds', extraUserRoleIdsLocal);
      return;
    }
    let oneOfRoleId: number = 0;
    let extraUserRoleIds: number[] = [];
    if (String(userRoleIdsFormLocal).includes("-")) {
      const ids: string[] = String(userRoleIdsFormLocal).split("-");
      ids.forEach((val: string) => {
        oneOfRoleId = Number(val);
        if (extraUserRoleIdsLocal.includes(oneOfRoleId)) {
          extraUserRoleIds.push(oneOfRoleId);
        }
      });
    } else {
      oneOfRoleId = Number(userRoleIdsFormLocal);
      if (extraUserRoleIdsLocal.includes(oneOfRoleId)) {
        extraUserRoleIds.push(oneOfRoleId);
      }
    }

    setValue('extraRoleIds', extraUserRoleIds);

    let entityName: string | undefined = userRoles?.find((option: UserRole) => Number(option.userRoleId) === oneOfRoleId)?.entityName;
    if (entityName) {
      if (entityName === USER_ROLE_ENTITY_NAMES.AGENCY) {
        setSelectedRoleEntity(AGENCY_ENTITY);
        const responseAgencies = dispatch(fetchAgenciesListUserSlice());
      } else if (entityName === USER_ROLE_ENTITY_NAMES.MANUFACTURER) {
        setSelectedRoleEntity(MANUFACTURER_ENTITY);
        const responseManufacturers = dispatch(fetchManufacturersListUserSlice());
      } else if (entityName === USER_ROLE_ENTITY_NAMES.PRACTICE) {
        setSelectedRoleEntity(PRACTICE_ENTITY);
        const responsePractices = dispatch(getPracticesByUserRoleUserSlice(true));
      } else if (entityName === USER_ROLE_ENTITY_NAMES.BILLER) {
        setSelectedRoleEntity(BILLER_ENTITY);
        const responseBillers = dispatch(fetchActiveBillersUserSlice());
      } else {
        setSelectedRoleEntity("");
      }
    } else {
      setSelectedRoleEntity("");
    }

  }, [watch("userRoleIdsForm")]);

  //Mount
  useEffect(() => {
    dispatch(showHideLoadingDialog(true))
    const fromBaa = location?.state?.fromBaa
    if(fromBaa) {
      notifyBaaAlert();
    };
    fetchInitialLists();
  }, []);

  useEffect(() => {
    if(userInfo.userRole === USER_ROLES.ROLE_PRACTICE_USER_PRU){      
      dispatch(showHideLoadingDialog(false));
    }
  }, [userInfo]);

  const notifyBaaAlert = () => {
    let infoObj: SingleAlertInfo = {
      message: "Please upload the Business Association Agreement (subcontractor version) by selecting the Import BAA option in the action menu.",
      alertType: "info"
    }
    setBaaAlert({
      show: true,
      obj: infoObj
    });
  }

  const fetchInitialLists = async () => {
    //Don't remove below unused variables
    if (userInfo.entityName === USER_ROLE_ENTITY_NAMES.AGENCY) {
      setLoggedInRoleEntity(AGENCY_ENTITY);
      const responseAgencies = await dispatch(fetchAgenciesListUserSlice());
    } else if (userInfo.entityName === USER_ROLE_ENTITY_NAMES.MANUFACTURER) {
      setLoggedInRoleEntity(MANUFACTURER_ENTITY);
      const responseManufacturers = await dispatch(fetchManufacturersListUserSlice());
    } else if (userInfo.entityName === USER_ROLE_ENTITY_NAMES.PRACTICE) {
      setLoggedInRoleEntity(PRACTICE_ENTITY);
      const responsePractices = await dispatch(getPracticesByUserRoleUserSlice(true));
    } else if (userInfo.entityName === USER_ROLE_ENTITY_NAMES.BILLER) {
      setLoggedInRoleEntity(BILLER_ENTITY);
      const responseBillers = await dispatch(fetchActiveBillersUserSlice());
    }
    const responseAllUserRoles = await dispatch(fetchAllUserRoles());
  }

  //Unmount
  useEffect(() => () => {
    dispatch(resetUserState());
  }, []);

  useEffect(() => {
    //1. When login another user pagination is remain in the history and can redirect that page
    if (userTypesList && userTypesList.length > 0 && onlyExtraRoleEntity && (onlyExtraRoleEntity === NONE_ENTITY || allExtraRoleEntityLoaded)) {
      const searchProvider = location.state?.providerData;
      if(searchProvider){
        setValue('userRoleIdsForm', 11);
        setValue('entityId', searchProvider.entityIds);
        setValue('extraEntityId', searchProvider.entityIds);
        setValue('firstName', searchProvider.firstName);
        setValue('lastName', searchProvider.lastName);
        setShowCard(true);
        
        // Create search criteria for provider
        const providerSearchCriteria: SearchUsers = {
          firstName: searchProvider.firstName,
          lastName: searchProvider.lastName,
          userRoleIdsForm: 11,
          userName: "",
          entityId: searchProvider.entityIds,
          extraEntityId: searchProvider.entityIds,
          extraRoleIds: [],
          phone: "",
          userStatus: ["Active"],
          currentPage: 1,
          itemsPerPage: ITEMS_PER_PAGE,
          //CS-1744 - Start
          fromDate: "",
          toDate: "",
          //CS-1744 - End
        };
        setTableSort({});
        setSearchCriteria(providerSearchCriteria);
        searchUsersList(providerSearchCriteria);
      } else {
        let criteria = getSearchCriteriaFromSessionStorage(CAN_ACCESS_APPLICATION.USER_MANAGEMENT + "SearchCriteria" + userInfo.userId);
        if ((location.state && location.state.userListSearchCriteria) || (location.state && location.state.withSearchHistory && criteria)) {
          if (location.state && location.state.withSearchHistory) {
            //Below navigate line call back to this useEffect - This for refreshing issue when navigate with state.withSearchHistory=true
            navigate("/user_list", { state: { userListSearchCriteria: criteria } });
            return;
          }
          let searchCriteria: SearchUsers = {
            firstName: "",
            lastName: "",
            userRoleIdsForm: null,
            userName: "",
            entityId: null,
            extraEntityId: undefined,
            extraRoleIds: [],
            phone: "",
            userStatus: [],
            currentPage: 0,
            itemsPerPage: 0,
            //CS-1744 - Start
            fromDate: "",
            toDate: "",
            //CS-1744 - End
          };
          if (location.state && location.state.userListSearchCriteria) {
            searchCriteria = location.state.userListSearchCriteria;
          } else {
            searchCriteria = criteria ? criteria : searchCriteria;
          }
          setSearchCriteria(searchCriteria);
          setTableSort(userListSort.pick(searchCriteria));
          setValuesToCriteriaFields(searchCriteria);

          searchUsersList(searchCriteria);
        } else {
          loadInitialUserList(1);
        }
      }
    }
}, [location.state, userTypesList, onlyExtraRoleEntity, allExtraRoleEntityLoaded, showBaaPopup?.show]);

  const setValuesToCriteriaFields = (searchCriteria: SearchUsers) => {
    setValue("firstName", searchCriteria.firstName);
    setValue("lastName", searchCriteria.lastName);
    setValue("userRoleIdsForm", searchCriteria.userRoleIdsForm);
    setValue("userName", searchCriteria.userName);
    setValue("extraEntityId", searchCriteria.extraEntityId);
    setValue("extraRoleIds", searchCriteria.extraRoleIds);
    setValue("entityId", searchCriteria.entityId);
    setValue("phone", searchCriteria.phone);
    setValue("userStatus", searchCriteria.userStatus);
    //CS-1744 - Start
    if (searchCriteria.fromDate && searchCriteria.toDate) {
      const fromDate = searchCriteria.fromDate || "";
      const toDate = searchCriteria.toDate || "";
      setValue(
        "dateRange",
        fromDate && toDate ? `${fromDate} - ${toDate}` : ""
      );
    } else if (searchCriteria.fromDate) {
      const fromDate = searchCriteria.fromDate || "";
      setValue(
        "dateRange",
        fromDate ? `${fromDate}` : ""
      );
    }
    //CS-1744 - End
  }

  const loadInitialUserList = (pNumber: number = 1) => {
    const data: SearchUsers = {
      firstName: "",
      lastName: "",
      userRoleIdsForm: userTypesList && userTypesList.length === 1 ? parseInt(userTypesList[0].value) : null,
      userName: "",
      extraEntityId: getValues("extraEntityId"),
      extraRoleIds: getValues("extraRoleIds"),
      entityId: getValues("entityId"),
      phone: "",
      userStatus: ["Active"],
      currentPage: pNumber,
      itemsPerPage: ITEMS_PER_PAGE,
      //CS-1744 - Start
      fromDate: "",
      toDate: "",
      //CS-1744 - End
    }
    setTableSort({});
    setSearchCriteria(data);
    setValuesToCriteriaFields(data);

    searchUsersList(data);
  }

  const searchUsersList = (
  searchCriteria: SearchUsers,
  sortOptions?: Pick<SearchUsers, "sortBy" | "sortOrder">
) => {
    const criteriaToStore = userListSort.normalize({
      ...searchCriteria,
      ...(sortOptions || {}),
    });

    setSearchCriteriaToSessionStorage(
      CAN_ACCESS_APPLICATION.USER_MANAGEMENT + "SearchCriteria" + userInfo.userId,
      criteriaToStore
    );

    let dataToSearch: SearchUsers = {
      ...criteriaToStore,
    };

    // setSearchCriteriaToSessionStorage(CAN_ACCESS_APPLICATION.USER_MANAGEMENT + "SearchCriteria" + userInfo.userId, searchCriteria);

    // let dataToSearch = {
    //   ...searchCriteria
    // }

    if (!dataToSearch.userRoleIdsForm) {
      let arry: number[] = [];
      userTypesList.forEach((option: TypeOption) => {
        if (!String(option.value).includes("-")) {
          arry.push(Number(option.value));
        }
      });
      dataToSearch.userRoleIds = arry;
    } else {
      if (String(dataToSearch.userRoleIdsForm).includes("-")) {
        let arry: number[] = [];
        const ids: string[] = String(dataToSearch.userRoleIdsForm).split("-");
        ids.forEach((val: string) => {
          arry.push(Number(val));
        });
        dataToSearch.userRoleIds = arry;
      } else {
        dataToSearch.userRoleIds = [Number(dataToSearch.userRoleIdsForm)];
      }
    }

    // if (extraUserRoleIdsLocal && extraUserRoleIdsLocal.length > 0) {
    //   let arryX: number[] = [];
    //   dataToSearch.userRoleIds.forEach((id: number) => {
    //     if (!extraUserRoleIdsLocal.includes(id)) {
    //       arryX.push(id);
    //     }
    //   });
    //   dataToSearch.userRoleIds = arryX;
    // }

    if (dataToSearch.extraRoleIds && dataToSearch.extraRoleIds.length > 0) {
      if (!dataToSearch.extraEntityId || dataToSearch.extraEntityId === 0) {
        if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === MANUFACTURER_ENTITY) {
          dataToSearch.extraEntityIds = manufacturerInfoListUserSlice && manufacturerInfoListUserSlice.length > 0
            ? manufacturerInfoListUserSlice?.map(manufacturer => Number(manufacturer.manufacturerId)) : [];
        } else if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === AGENCY_ENTITY) {
          dataToSearch.extraEntityIds = agencyInfoListUserSlice && agencyInfoListUserSlice.length > 0
            ? agencyInfoListUserSlice?.map(agency => Number(agency.agencyId)) : [];
        } else if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === PRACTICE_ENTITY) {
          dataToSearch.extraEntityIds = practiceByUserRoleUserSlice && practiceByUserRoleUserSlice.length > 0
            ? practiceByUserRoleUserSlice?.map(practice => Number(practice.practiceId)) : [];
        } else if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === BILLER_ENTITY) {
          dataToSearch.extraEntityIds = billerListUserSlice && billerListUserSlice.length > 0
            ? billerListUserSlice?.map(biller => Number(biller.billerId)) : [];
        }
      } else {
        dataToSearch.extraEntityIds = [dataToSearch.extraEntityId];
      }
    }

    if (userInfo.entityName === USER_ROLE_ENTITY_NAMES.ADMIN) {
      if (dataToSearch.extraRoleIds && dataToSearch.extraRoleIds.length > 0) {
        dataToSearch.userRoleIds = Array.from(new Set([
          ...(dataToSearch.userRoleIds || []),
          ...dataToSearch.extraRoleIds
        ]));
      }
      dataToSearch.extraRoleIds = [];
    } else {
        if((dataToSearch.userRoleIds && dataToSearch.userRoleIds.length>0)
          && (dataToSearch.extraRoleIds && dataToSearch.extraRoleIds.length>0)
        ){
          dataToSearch.userRoleIds = dataToSearch.userRoleIds.filter(
            roleId => !dataToSearch.extraRoleIds.includes(roleId)
          );
        }
    }

    if (!dataToSearch.userStatus || dataToSearch.userStatus.length === 0) {
      dataToSearch.userStatus = statusOptions && statusOptions.length > 0 ? statusOptions?.map(status => status.value) : [];
    }

    //Restricted the search if no extraEntityIds for account executive users.
    if (userInfo.entityName === USER_ROLE_ENTITY_NAMES.ACCOUNTEXECUTIVE && (!dataToSearch.extraEntityIds || dataToSearch.extraEntityIds.length === 0)) {
      dispatch(showHideLoadingDialog(false))
      return;
    }
    if (userInfo.userRole !== USER_ROLES.ROLE_PRACTICE_USER_PRU) {
      dispatch(searchUserList(dataToSearch));
    }
  }

  const onSubmit = (data: SearchUsers) => {
    //CS-1744 - Start
    if (!isDateRangeChanged) {
      setValue("fromDate", "");
      setValue("toDate", "");
      setValue("dateRange", "");
      setIsClearDateRange(true);
    }
    //CS-1744 - End
    const data2: SearchUsers = {
      firstName: data.firstName,
      lastName: data.lastName,
      userRoleIdsForm: data.userRoleIdsForm,
      userName: data.userName,
      extraEntityId: data.extraEntityId,
      extraRoleIds: data.extraRoleIds,
      entityId: typeof data.entityId === "number" ? data.entityId : null,
      phone: data.phone,
      userStatus: data.userStatus,
      currentPage: 1,
      itemsPerPage: ITEMS_PER_PAGE,
      //CS-1744 - Start
      fromDate: isDateRangeChanged ? data.fromDate : "",
      // toDate: isDateRangeChanged ? data.toDate : "",
      toDate: isDateRangeChanged ? (data.toDate || data.fromDate) : "", // CS-1744: if only fromDate set, use it as toDate for exact day match
      //CS-1744 - End
      ...userListSort.pick(tableSort),
    }
    setSearchCriteria(data2);

    //Below navigate line call to useEffect[location.state, userTypesList, onlyExtraRoleEntity, allExtraRoleEntityLoaded] and search
    navigate("/user_list", { state: { userListSearchCriteria: data2 } });
  }

  const handlePagination = (pageNumber: number) => {
    const data = {
      ...searchCriteria,
      currentPage: pageNumber + 1
    }
    setSearchCriteria(data);
    searchUsersList(data, tableSort);
  }

  const handleTableSort = (columnId: string, order: "asc" | "desc") => {
    const data = userListSort.withSort(searchCriteria, columnId, order);
    if (!data) {
      return;
    }
    setTableSort(userListSort.pick(data));
    setSearchCriteria(data);
    searchUsersList(data);
  };


  //CS-1744 - Start
  const handleDateRangeChange = (fromDate: DateObject | null, toDate: DateObject | null) => {
    const fromDateString = fromDate ? fromDate.format("MM/DD/YYYY") : null;
    const toDateString = toDate ? toDate.format("MM/DD/YYYY") : null;
    setValue("fromDate", fromDateString || "");
    setValue("toDate", toDateString || "");

    setIsDateRangeChanged(true);
  };
  //CS-1744 - End

  const handleUserTypeSelectChange = (option: TypeOption, value: string) => {
    if (!onlyExtraRoleEntity) {
      setValue('extraEntityId', 0);
    }

    if (!loggedInRoleEntity) {
      setValue('entityId', 0);
    }
  }

  const clickShowPasswordResetPopup = () => {
    setShowPasswordResetPopup(true);
  }

  const handleActionEdit = (row: any) => {
    const { userName, userId, firstName, lastName, email, phone } = row;
    dispatch(fetchUserProfileById(parseInt(userId)));
    navigate("/user_create", {
      state: { user: { userName, userId, firstName, lastName, email, phone } },
    });
  }

  const handleActionActiveUser = (row: any) => {
    const { userId, userStatus } = row;
    setUserID(userId);
    setUserProfileStatus(userStatus);
    setShowInactivePopup(true);
  }

  const handleActionInactiveUser = async (row: any) => {

    const result = await dispatch(fetchIsLastProviderByUser(row.userId));
    let isLastProvider = false;
    if(result && result.payload) {
      isLastProvider = result.payload.data;
    }

    if (isLastProvider) {
      setInactiveProvider({
        message:
          "At least 1 practice provider is required.",
        show: true
      });
    } else {

      setInactiveProvider({
        message:"",
        show: false
      });

      const { userId, userStatus } = row;
      setUserID(userId);
      setUserProfileStatus(userStatus);
      setShowInactivePopup(true);
    }
  }

  const handleActionResetPassword = (row: any) => {
    const { userId, email } = row;
    dispatch(fetchUserProfileById(parseInt(userId)));
    setUserEmail(email);
    setUserID(userId);
    clickShowPasswordResetPopup();
  }

  const handleCloseInactivePopup = (reloadList: boolean) => {
    setShowInactivePopup(false);
    if (reloadList) {
      searchUsersList(searchCriteria);
    }
  }

  const handleImportBaa = (row: any) => {
    setShowBaaPopup({
      show: true,
      userEntity: "USER",
      details: row
    });
  }

  //CS-518 Passing the IVR details to audit log
  const handleClickUserAudit = (data: any) => {
    if (data && data.email) {
      const UserAuditData = {
        entityName: "USER",
        entityNumber: data?.email
      }

      const url = `/auditlog?entityName=${UserAuditData.entityName}&entityNumber=${UserAuditData.entityNumber}`;
      window.open(url, '_blank');
    //   // navigate("/auditlog", '_blank',{ state: { entityName: IVRAuditData.entityName, entityNumber: IVRAuditData.entityNumber } });
    }
  }
  //

  //CS-1071 - Start
  const handleActionButtonClick = (buttonId: string, originalClick: () => void) => {
    const currentPageKey = "userList"; // Or dynamically set this value based on the current page
    saveSelectionForPage(currentPageKey, buttonId);
    setActiveButtonId(buttonId);
    sessionStorage.setItem("activeActionButtonId", buttonId);
    originalClick(); // Call the button's actual logic
  };
  //CS-1071 - End

  //CS-1555 - Start
  const handleRowNavigateToEdit = (row: TableRow) => {
    const userId = String((row as any).userId);
    handleActionButtonClick(`userListActionButton-${userId}`, () => handleActionEdit(row));
  };

  const handleExportList = () => {
    // Use the same logic as searchUsersList but add downloadState
    let exportData = {
      ...searchCriteria,
      downloadState: true
    }

    if (!exportData.userRoleIdsForm) {
      let arry: number[] = [];
      userTypesList.forEach((option: TypeOption) => {
        if (!String(option.value).includes("-")) {
          arry.push(Number(option.value));
        }
      });
      exportData.userRoleIds = arry;
    } else {
      if (String(exportData.userRoleIdsForm).includes("-")) {
        let arry: number[] = [];
        const ids: string[] = String(exportData.userRoleIdsForm).split("-");
        ids.forEach((val: string) => {
          arry.push(Number(val));
        });
        exportData.userRoleIds = arry;
      } else {
        exportData.userRoleIds = [Number(exportData.userRoleIdsForm)];
      }
    }

    if (exportData.extraRoleIds && exportData.extraRoleIds.length > 0) {
      if (!exportData.extraEntityId || exportData.extraEntityId === 0) {
        if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === MANUFACTURER_ENTITY) {
          exportData.extraEntityIds = manufacturerInfoListUserSlice && manufacturerInfoListUserSlice.length > 0
            ? manufacturerInfoListUserSlice?.map(manufacturer => Number(manufacturer.manufacturerId)) : [];
        } else if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === AGENCY_ENTITY) {
          exportData.extraEntityIds = agencyInfoListUserSlice && agencyInfoListUserSlice.length > 0
            ? agencyInfoListUserSlice?.map(agency => Number(agency.agencyId)) : [];
        } else if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === PRACTICE_ENTITY) {
          exportData.extraEntityIds = practiceByUserRoleUserSlice && practiceByUserRoleUserSlice.length > 0
            ? practiceByUserRoleUserSlice?.map(practice => Number(practice.practiceId)) : [];
        } else if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === BILLER_ENTITY) {
          exportData.extraEntityIds = billerListUserSlice && billerListUserSlice.length > 0
            ? billerListUserSlice?.map(biller => Number(biller.billerId)) : [];
        }
      } else {
        exportData.extraEntityIds = [exportData.extraEntityId];
      }
    }

    if (userInfo.entityName === USER_ROLE_ENTITY_NAMES.ADMIN) {
      if (exportData.extraRoleIds && exportData.extraRoleIds.length > 0) {
        exportData.userRoleIds = Array.from(new Set([
          ...(exportData.userRoleIds || []),
          ...exportData.extraRoleIds
        ]));
      }
      exportData.extraRoleIds = [];
    } else {
        if((exportData.userRoleIds && exportData.userRoleIds.length>0)
          && (exportData.extraRoleIds && exportData.extraRoleIds.length>0)
        ){
          exportData.userRoleIds = exportData.userRoleIds.filter(
            roleId => !exportData.extraRoleIds.includes(roleId)
          );
        }
    }

    if (!exportData.userStatus || exportData.userStatus.length === 0) {
      exportData.userStatus = statusOptions && statusOptions.length > 0 ? statusOptions?.map(status => status.value) : [];
    }

    //Restricted the export if no extraEntityIds for account executive users.
    if (userInfo.entityName === USER_ROLE_ENTITY_NAMES.ACCOUNTEXECUTIVE && (!exportData.extraEntityIds || exportData.extraEntityIds.length === 0)) {
      handleMenuClose();
      return;
    }

    ExportToExcel(exportData, columns, dispatch, "USER");
    handleMenuClose();
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMenu(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorElMenu(null);
  };
  //CS-1555 - End

  const actionComponent = (row: any): JSX.Element => {
    const { userStatus } = row;
    return (
      <>
        <CustomIconButton
          color="info"
          size="small"
          variant="outlined"
          tooltipMessage="Edit"
          tooltipPlacement="top"
          //CS-1071 - Start
          onClick={() =>  handleActionButtonClick(`userListActionButton-${row.userId}`, () =>handleActionEdit(row))}
          //CS-1071 - End       
        >
          <ModeOutlined fontSize="small" />
        </CustomIconButton>

        <CustomIconButton
          color="warning"
          size="small"
          variant="outlined"
          tooltipMessage="Reset Password"
          tooltipPlacement="top"
          //CS-1071 - Start
          onClick={() => handleActionButtonClick(`userListActionButton-${row.userId}`, () => handleActionResetPassword(row))}
          //CS-1071 - End
        >
          <VpnKey fontSize="small" />
        </CustomIconButton>

        {userStatus === "Active" && (
          <CustomIconButton
            color="error"
            size="small"
            variant="outlined"
            tooltipMessage="Inactivate User"
            tooltipPlacement="top"
            //CS-1071 - Start
            onClick={() => handleActionButtonClick(`userListActionButton-${row.userId}`, () => handleActionInactiveUser(row))}
            //CS-1071 - End
          >
            <DoDisturbAltOutlined fontSize="small" />
          </CustomIconButton>
        )}
        {userStatus === "Inactive" && (
          <CustomIconButton
            color="success"
            size="small"
            variant="outlined"
            tooltipMessage="Activate User"
            tooltipPlacement="top"
            //CS-1071 - Start
            onClick={() => handleActionButtonClick(`userListActionButton-${row.userId}`, () => handleActionActiveUser(row))}
            //CS-1071 - End
          >
            <CheckCircleOutline fontSize="small" />
          </CustomIconButton>
        )}
        {(userStatus === "Active" && row?.baaDetailIds?.length === 0) && (
          <CustomIconButton
            color="info"
            size="small"
            variant="outlined"
            tooltipMessage="Import BAA"
            tooltipPlacement="top"
            //CS-1071 - Start
            onClick={() =>  handleActionButtonClick(`userListActionButton-${row.userId}`, () =>handleImportBaa(row))}
            //CS-1071 - End
          >
            <AssignmentReturnedOutlined fontSize="small" />
          </CustomIconButton>
        )}
         <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="User Audit"
          color="warning"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!canAuditUser)}` }}
          //CS-1071 - Start
          onClick={() => handleActionButtonClick(`userListActionButton-${row.userId}`, () => handleClickUserAudit(row)) }
          //CS-1071 - End
        >
          <TrackChanges fontSize="small" />
        </CustomIconButton>
        {/* <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Permissions"
          color="info"
          size="small"
          variant="outlined"
          onClick={() => handleClickPermissions(row) }
        >
          <LockOpenOutlined fontSize="small" />
        </CustomIconButton> */}
      </>
    );
  };

  const userData: Row[] = useMemo(() => {
    let users: Row[] = [];
    if (searchUsers && searchUsers.content && Array.isArray(searchUsers.content)) {
      users = searchUsers.content.map((user: any) => ({
        email: user.email,
        userRole: user.userRole,
        userName: user.userName,
        firstName: user.firstName,
        middleName: user.middleName,
        lastName: user.lastName,
        phone: user.phone,
        createDate: formatDate(user.requestTimestamp),
        lastLoginAt: convertUTCtoLocal(user.lastLoginAt),
        rawLastLoginAt: user.lastLoginAt ?? "",
        userStatus: user.userStatus?.toUpperCase(),
        action: actionComponent(user),
        userId: user.userId,
      }));
    } 
    return users;
  }, [searchUsers]);

  useEffect(() => {
    if (searchUsers) {
      dispatch(showHideLoadingDialog(false))
    }
  }, [searchUsers])

  const legacyItems = [
    { icon: <ModeOutlined color="info" />, text: "Edit" },
    { icon: <CheckCircleOutline color="success" />, text: "Activate User" },
    { icon: <DoDisturbAltOutlined color="error" />, text: "Inactivate User" },
    { icon: <VpnKey color="warning" />, text: "Reset Password" },
  ];

  const totalRecords = searchUsers?.totalElements ?? 0;
  return (
    <>
      {showPasswordResetPopup &&
        <PasswordResetPopup
          open={showPasswordResetPopup}
          email={userEmail}
          userId={userID}
          onClose={() => {
            setShowPasswordResetPopup(false);
          }}
        />
      }
      {showInactivePopup &&
        <InactiveUserPopup
          open={showInactivePopup}
          userId={userID}
          userRoleId={Number(getValues("userRoleIdsForm"))}
          userStatus={userProfileStatus}
          onClose={(reloadList: boolean) => {
            handleCloseInactivePopup(reloadList);
          }}
        />
      }
      <ErrorDialog
        open={isLastPracticeProvider && inactiveProvider.show}
        onClose={() =>
          setInactiveProvider({ message: "", show: false })
        }
        content={inactiveProvider.message}
      />
      {showBaaPopup?.show &&
        <UploadBaaPopup
          open={showBaaPopup.show}
          onClose={() => setShowBaaPopup({ show: false, userEntity: "USER", details: null })}
          userEntity={showBaaPopup.userEntity}
          details={showBaaPopup.details}
        />
      }
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          px: { xs: 1, md: 3 },
          py: 2,
        }}
      >
        {/* <Header title="User List" /> */}
        <Box sx={{ position: "relative", zIndex: 20, overflow: "visible" }}>
          <Collapse in={showCard} ref={filterPanelRef} onEntering={handleFilterPanelEntering} onEntered={handleFilterPanelEntered} onExited={handleFilterPanelExited}>
            <Card sx={filterPanelSx}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} alignItems="flex-end">
                  <Grid item md={3} xs={12}>
                    <CustomDropdownField name="userRoleIdsForm" control={control} label="User Type" placeholderText="Select user type" options={userTypesList}
                      onChangeSelect={handleUserTypeSelectChange} disabled={userTypesList && userTypesList.length === 1} sortOptions={false} size="small" />
                  </Grid>
                  {(selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity) ? (
                    <Grid item md={3} xs={12}>
                      {(selectedRoleEntity === AGENCY_ENTITY) && (
                        <CustomDropdownField name="extraEntityId" control={control} options={agencyList} label="Agency" placeholderText="Select agency"
                          disabled={agencyList && agencyList.length === 1} size="small" />
                      )}
                      {(selectedRoleEntity === MANUFACTURER_ENTITY) && (
                        <CustomDropdownField name="extraEntityId" control={control} options={manufacturersList} label="Manufacturer" placeholderText="Select manufacturer"
                          disabled={manufacturersList && manufacturersList.length === 1} size="small" />
                      )}
                      {(selectedRoleEntity === PRACTICE_ENTITY) && (
                        <CustomDropdownField name="extraEntityId" control={control} options={practiceList} label="Practice" placeholderText="Select practice"
                          disabled={practiceList && practiceList.length === 1} size="small" />
                      )}
                      {(selectedRoleEntity === BILLER_ENTITY) && (
                        <CustomDropdownField name="extraEntityId" control={control} options={billerUsersList} label="Biller" placeholderText="Select biller"
                          disabled={billerUsersList && billerUsersList.length === 1} size="small" />
                      )}
                    </Grid>
                  ) : null}
                  {(((selectedRoleEntity && !loggedInRoleEntity) || (!selectedRoleEntity && loggedInRoleEntity))
                    || (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity === loggedInRoleEntity)) ? (
                    <Grid item md={3} xs={12}>
                      {(loggedInRoleEntity === AGENCY_ENTITY || selectedRoleEntity === AGENCY_ENTITY) && (
                        <CustomDropdownField name="entityId" control={control} options={agencyList} label="Agency" placeholderText="Select agency"
                          disabled={agencyList && agencyList.length === 1} size="small" />
                      )}
                      {(loggedInRoleEntity === MANUFACTURER_ENTITY || selectedRoleEntity === MANUFACTURER_ENTITY) && (
                        <CustomDropdownField name="entityId" control={control} options={manufacturersList} label="Manufacturer" placeholderText="Select manufacturer"
                          disabled={manufacturersList && manufacturersList.length === 1} size="small" />
                      )}
                      {(loggedInRoleEntity === PRACTICE_ENTITY || selectedRoleEntity === PRACTICE_ENTITY) && (
                        <CustomDropdownField name="entityId" control={control} options={practiceList} label="Practice" placeholderText="Select practice"
                          disabled={practiceList && practiceList.length === 1} size="small" />
                      )}
                      {(loggedInRoleEntity === BILLER_ENTITY || selectedRoleEntity === BILLER_ENTITY) && (
                        <CustomDropdownField name="entityId" control={control} options={billerUsersList} label="Biller" placeholderText="Select biller"
                          disabled={billerUsersList && billerUsersList.length === 1} size="small" />
                      )}
                    </Grid>
                  ) : null}
                  {/* {((selectedRoleEntity || loggedInRoleEntity)) ? (
                    <Grid item md={3} xs={12}>
                      {((loggedInRoleEntity === AGENCY_ENTITY && !selectedRoleEntity) || (selectedRoleEntity === AGENCY_ENTITY && !loggedInRoleEntity)
                      || (selectedRoleEntity && loggedInRoleEntity && loggedInRoleEntity === AGENCY_ENTITY)) && (
                        <CustomDropdownField name="entityId" control={control} options={agencyList} label="Agency"
                          disabled={agencyList && agencyList.length === 1} />
                      )}
                      {((loggedInRoleEntity === MANUFACTURER_ENTITY && !selectedRoleEntity) || (selectedRoleEntity === MANUFACTURER_ENTITY && !loggedInRoleEntity)
                      || (selectedRoleEntity && loggedInRoleEntity && loggedInRoleEntity === MANUFACTURER_ENTITY)) && (
                        <CustomDropdownField name="entityId" control={control} options={manufacturersList} label="Manufacturer"
                          disabled={manufacturersList && manufacturersList.length === 1} />
                      )}
                      {((loggedInRoleEntity === PRACTICE_ENTITY && !selectedRoleEntity) || (selectedRoleEntity === PRACTICE_ENTITY && !loggedInRoleEntity)
                      || (selectedRoleEntity && loggedInRoleEntity && loggedInRoleEntity === PRACTICE_ENTITY)) && (
                        <CustomDropdownField name="entityId" control={control} options={practiceList} label="Practice"
                          disabled={practiceList && practiceList.length === 1} />
                      )}
                      {((loggedInRoleEntity === BILLER_ENTITY && !selectedRoleEntity) || (selectedRoleEntity === BILLER_ENTITY && !loggedInRoleEntity)
                      || (selectedRoleEntity && loggedInRoleEntity && loggedInRoleEntity === BILLER_ENTITY)) && (
                        <CustomDropdownField name="entityId" control={control} options={billerUsersList} label="Biller"
                          disabled={billerUsersList && billerUsersList.length === 1} />
                      )}
                    </Grid>
                  ) : null} */}
                  <Grid item md={3} xs={12}>
                    <CustomMultipleDropDown name="userStatus" control={control} label="User Status" placeholderText="Select status" options={statusOptions} size="small" />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomTextField control={control} controllerName="userName" label="Email" placeholder="Enter email" size="small" />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomTextField control={control} controllerName="firstName" label="First Name" placeholder="Enter first name" size="small" />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomTextField control={control} controllerName="lastName" label="Last Name" placeholder="Enter last name" size="small" />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomPatternTextField control={control} name="phone" label="Phone" placeholder="Enter phone" size="small" />
                  </Grid>
                  {/* CS-1744 - Add Login Date Range Filter */}
                  <Grid item md={3} xs={12}>
                    <CustomDateRange
                      label="Login Date Range"
                      control={control}
                      controllerName="dateRange"
                      onChange={handleDateRangeChange}
                      onClear={isClearDateRange}
                    />
                  </Grid>
                  {/* CS-1744 - End */}
                  <Grid item md={3} xs={12}>
                    <Button fullWidth size="large" color="success" startIcon={<SearchOutlined />} sx={{ ...primaryActionBtnSx, height: "42px", py: 0 }} type="submit" removeUpperCase>
                      Search
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Card>
          </Collapse>
        </Box>
        <Box mt={2} sx={{ position: "relative", zIndex: 1 }}>
          <Card sx={{ ...cardSx, p: { xs: "14px !important", md: "18px !important" }, position: "relative", zIndex: 1 }}>
            <Grid container justifyContent="space-between" alignItems="center" spacing={1.2}>
              <Grid item xs={12} md>
                <Typography variant='h3' fontWeight={800} color="text.primary">User List</Typography>
              </Grid>
              <Grid item xs={12} md="auto">
                <Button variant="outlined" color="info" onClick={toggleFilterPanel} startIcon={<SearchOutlined />} fullWidth sx={outlineBtnSx} removeUpperCase>
                  {showCard ? "Hide Filters" : "Show Filters"}
                </Button>
              </Grid>
              {userInfo.userRole !== USER_ROLES.ROLE_PRACTICE_USER_PRU &&
                <Grid item xs={12} md="auto">
                  <Button fullWidth color="info" startIcon={<AddCircleOutlineOutlined />} onClick={() => navigate("/user_create")} sx={primaryActionBtnSx} removeUpperCase>
                    Create User
                  </Button>
                </Grid>
              }
              {canExportList &&
                <Grid item xs={12} md="auto">
                  <Box>
                    {!isMobile && (
                      <Button
                        id="customized-button"
                        aria-controls={Boolean(anchorElMenu) ? "customized-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={Boolean(anchorElMenu) ? "true" : undefined}
                        variant="outlined"
                        disableElevation
                        onClick={handleMenuClick}
                        startIcon={<ExitToApp />}
                        sx={exportBtnSx}
                        removeUpperCase
                        endIcon={
                          <Box
                            component="span"
                            sx={{
                              display: "flex",
                              transition: "transform 0.3s ease",
                              transform: anchorElMenu ? "rotate(180deg)" : "rotate(0deg)",
                              padding: "2px"
                            }}
                          >
                            <KeyboardArrowDown />
                          </Box>
                        }
                        fullWidth
                      >
                        Export
                      </Button>
                    )}

                    <StyledMenu
                      id="customized-menu"
                      MenuListProps={{ "aria-labelledby": "customized-button" }}
                      anchorEl={anchorElMenu}
                      open={Boolean(anchorElMenu)}
                      onClose={handleMenuClose}
                      slotProps={{
                        paper: { sx: exportMenuPaperSx }
                      }}
                    >
                        <>
                          <Box sx={{ px: 1, mb: 1 }}>
                            <Button
                              fullWidth
                              variant="outlined"
                              startIcon={<CloudDownload />}
                              disabled={totalRecords > 1000}
                              onClick={handleExportList}
                              sx={exportMenuItemBtnSx}
                              removeUpperCase
                            >
                              Export Search List
                            </Button>
                          </Box>
                          
                          <Box sx={{ px: 1, mb: 1 }}>
                            <Button
                              fullWidth
                              variant="outlined"
                              startIcon={<CloudDownload />}
                              disabled={totalRecords > 1000}
                              onClick={() => {
                                let exportData = {
                                  ...searchCriteria,
                                  downloadState: true
                                }

                                if (!exportData.userRoleIdsForm) {
                                  let arry: number[] = [];
                                  userTypesList.forEach((option: TypeOption) => {
                                    if (!String(option.value).includes("-")) {
                                      arry.push(Number(option.value));
                                    }
                                  });
                                  exportData.userRoleIds = arry;
                                } else {
                                  if (String(exportData.userRoleIdsForm).includes("-")) {
                                    let arry: number[] = [];
                                    const ids: string[] = String(exportData.userRoleIdsForm).split("-");
                                    ids.forEach((val: string) => {
                                      arry.push(Number(val));
                                    });
                                    exportData.userRoleIds = arry;
                                  } else {
                                    exportData.userRoleIds = [Number(exportData.userRoleIdsForm)];
                                  }
                                }

                                if (exportData.extraRoleIds && exportData.extraRoleIds.length > 0) {
                                  if (!exportData.extraEntityId || exportData.extraEntityId === 0) {
                                    if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === MANUFACTURER_ENTITY) {
                                      exportData.extraEntityIds = manufacturerInfoListUserSlice && manufacturerInfoListUserSlice.length > 0
                                        ? manufacturerInfoListUserSlice?.map(manufacturer => Number(manufacturer.manufacturerId)) : [];
                                    } else if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === AGENCY_ENTITY) {
                                      exportData.extraEntityIds = agencyInfoListUserSlice && agencyInfoListUserSlice.length > 0
                                        ? agencyInfoListUserSlice?.map(agency => Number(agency.agencyId)) : [];
                                    } else if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === PRACTICE_ENTITY) {
                                      exportData.extraEntityIds = practiceByUserRoleUserSlice && practiceByUserRoleUserSlice.length > 0
                                        ? practiceByUserRoleUserSlice?.map(practice => Number(practice.practiceId)) : [];
                                    } else if (selectedRoleEntity && loggedInRoleEntity && selectedRoleEntity !== loggedInRoleEntity && selectedRoleEntity === BILLER_ENTITY) {
                                      exportData.extraEntityIds = billerListUserSlice && billerListUserSlice.length > 0
                                        ? billerListUserSlice?.map(biller => Number(biller.billerId)) : [];
                                    }
                                  } else {
                                    exportData.extraEntityIds = [exportData.extraEntityId];
                                  }
                                }

                                if (userInfo.entityName === USER_ROLE_ENTITY_NAMES.ADMIN) {
                                  if (exportData.extraRoleIds && exportData.extraRoleIds.length > 0) {
                                    exportData.userRoleIds = Array.from(new Set([
                                      ...(exportData.userRoleIds || []),
                                      ...exportData.extraRoleIds
                                    ]));
                                  }
                                  exportData.extraRoleIds = [];
                                } else {
                                    if((exportData.userRoleIds && exportData.userRoleIds.length>0)
                                      && (exportData.extraRoleIds && exportData.extraRoleIds.length>0)
                                    ){
                                      exportData.userRoleIds = exportData.userRoleIds.filter(
                                        roleId => !exportData.extraRoleIds.includes(roleId)
                                      );
                                    }
                                }

                                if (!exportData.userStatus || exportData.userStatus.length === 0) {
                                  exportData.userStatus = statusOptions && statusOptions.length > 0 ? statusOptions?.map(status => status.value) : [];
                                }

                                if (userInfo.entityName === USER_ROLE_ENTITY_NAMES.ACCOUNTEXECUTIVE && (!exportData.extraEntityIds || exportData.extraEntityIds.length === 0)) {
                                  handleMenuClose();
                                  return;
                                }

                                ExportToExcel(exportData, columns, dispatch, EXPORTABLE_ITEMS.USER_DETAILS);
                                handleMenuClose();
                              }}
                              sx={exportMenuItemBtnSx}
                              removeUpperCase
                            >
                              Export Details List
                            </Button>
                          </Box>
                        </>

                      {totalRecords > 1000 && (
                      <Box
                        sx={{
                          mx: 1,
                          p: 1.5,
                          mt: 1,
                          backgroundColor: "warning.light",
                          borderRadius: 1,
                          color: "warning.contrastText",
                        }}
                      >
                        <Typography variant="body2">
                          Export is available only when the list contains 1,000 records or fewer.
                          Maximum export size: 1000 records.
                        </Typography>
                      </Box>
                      )}
                    </StyledMenu>
                  </Box>
                </Grid>
              }

              {canExportList && isMobile &&
                <Box position="absolute" mt={1}>
                  <Button
                    color="success"
                    variant="text"
                    onClick={handleMenuClick}
                    startIcon={<DownloadOutlined fontSize="small" />}
                    sx={exportBtnSx}
                    removeUpperCase
                  >
                    Export
                  </Button>
                </Box>
              }
            </Grid>
            <Table
              columns={filteredColumns}
              rows={userData}
              actionComponent={(row: any) => actionComponent(row)}
              totalPages={searchUsers?.totalPages}
              totalElementText={"Records: " + (searchUsers?.totalElements ? searchUsers?.totalElements : "0")}
              pageNumber={(thisPage: number) => handlePagination(thisPage)}
              emptyText="No User(s) Found"
              currentPageNumber={searchCriteria.currentPage - 1}
              showMenu={true}
              // CS-1071 - Start
              currentPageKey={"userList"}
              uniqueValue="userId"
              activeButtonId={activeButtonId}
              // CS-1071 - End
              // CS-1555 - Start
              onRowClick={handleRowNavigateToEdit}
              clickableCards={true}
              // CS-1555 - End
              sortableColumns={userListSort.sortableColumns}
              onSortChange={handleTableSort}
              serverSideSorting
              controlledSortColumn={userListSort.controlledColumn(tableSort.sortBy)}
              controlledSortOrder={tableSort.sortOrder ?? null}
              sx={tableSx}
            />
          </Card>
        </Box>
      </Box>
      {
        baaAlert?.show && 
        <CustomSingleAlert
        open={baaAlert?.show}
        singleAlertObj={baaAlert.obj}
        autoHideDuration={20000}
        onClose={() => setBaaAlert({show:false, obj:{message: "", alertType: "info" }})}
      />
      }
    </>
  );
}

export default UserList;
